import React from 'react';
import { InputGroup, Button, Intent } from "@blueprintjs/core";
import style from './index.module.scss';

const SearchBar = ({ getSearchKey, searchKey, className, placeholder, onAiClick, aiActive }) => {
  const rightElement = (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Button icon="search" intent={Intent.PRIMARY} minimal={true} />
      {/* Query icon (/) hidden until functionality is fully integrated */}
      {/* <button
        onClick={(e) => { e.stopPropagation(); e.preventDefault(); onAiClick && onAiClick(); }}
        style={{
          background: aiActive ? '#857AEF' : 'none',
          border: aiActive ? 'none' : '1px solid #c5bff5',
          borderRadius: 6,
          cursor: 'pointer',
          fontWeight: 700,
          fontSize: 15,
          color: aiActive ? '#fff' : '#857AEF',
          padding: '1px 8px',
          marginRight: 4,
          fontFamily: 'monospace',
          lineHeight: 1.4,
          transition: 'all 0.15s',
        }}
        title=""
      >
        /
      </button> */}
    </div>
  );

  return (
    <InputGroup
      large={true}
      round={true}
      type="search"
      placeholder={placeholder}
      value={searchKey}
      rightElement={rightElement}
      onChange={(e) => getSearchKey(e.target.value)}
      className={`${className} ${style.searchBarStyle} .bp4-round`}
      style={aiActive ? { boxShadow: '0 0 0 2px #857AEF44' } : {}}
    />
  );
};

export default SearchBar;
